
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TrackingUserActivityType, TrackingUser } from '@/types/Tracking'

@Component
export default class UserItemInfoIcons extends Vue {
  @Prop({ required: true })
  user: TrackingUser

  ACTIVITY_TYPE = TrackingUserActivityType

  /**
   * Get the corresponding text for precision title
   */
  get precisionText () {
    return ` (${this.user.activityConfidence}% de probabilidad)`
  }
}
